import styled from "styled-components";
import { BodyDefault, BodyMedium, BodySmall, HeadLine2 } from "../../../../components/typography/styled";
import SVG from "react-inlinesvg";
export const Container = styled.div`
  align-self: start;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 535px;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom:10px;
  width: 100%;
`

export const Title = styled(HeadLine2)`
  color:${({theme}) => theme.palette[850]};
`
export const Link = styled(BodyDefault)`
  color:${({theme}) => theme.icon.primary};
  &:hover{
    cursor:pointer;
  }
`

export const Day = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  border-radius: 4px;
  margin-bottom: 10px;
  gap: 10px;
  width: 53px;
  height: 28px;
  background:${({theme}) => theme.palette[200]};
`

export const DayText = styled(BodySmall)`
  color:${({theme}) => theme.palette[800]};
`

export const Time = styled(BodyDefault)`
  flex: 0 0 68px;
  width: 68px;
  color:${({theme}) => theme.palette[700]};
  margin-right: 20px;
`

export const LogItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding: 6px 0;
  min-height: 32px;
  box-shadow: ${({theme}) => `inset 0 -1px ${theme.palette[300]}`};
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  &:not(:nth-child(3)) {
    box-shadow: ${({theme}) => `inset 0 -1px ${theme.palette[350]}`};
  }

  &:last-child ${Time} {
    flex-basis: 67px;
    width: 67px;
    margin-right: 24px;
  }
`
export const SettingsIcon = styled(SVG)`
  width:18px;
  height:18px;
  margin-right:4px;
`
export const LogName = styled(BodyMedium)`
  color:${({theme}) => theme.palette[900]};
`
export const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width:100%;
  justify-content: space-between;
`

export const Action = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`

export const Content = styled(BodyDefault)`
  display: flex;
  flex: 0 0 233px;
  gap: 7px;
  width: 233px;
  color:${({theme}) => theme.palette[900]};
  text-align: left;
`
